import { tns } from 'tiny-slider/src/tiny-slider';
import {
	shouldAutoplaySlider,
	wireTnsAutoplayToggle,
} from '../util/slider-autoplay-toggle';

class TestimonialsSlider {
	constructor(el, prevButton, nextButton, options = {}) {
		this.el = el;
		this.prevButton = prevButton;
		this.nextButton = nextButton;

		const autoplayEnabled =
			options.autoplay === false ? false : shouldAutoplaySlider();

		const defaults = {
			container: this.el,
			items: 1,
			slideBy: 1,
			mode: 'gallery',
			autoplay: autoplayEnabled,
			autoplayButtonOutput: false,
			speed: 400,
			controls: true,
			prevButton: this.prevButton,
			nextButton: this.nextButton,
		};

		const updateSlideFocus = () => {
			const sliderEnabled = this.el.classList.contains('tns-slider');
			this.el.querySelectorAll('.tns-item').forEach((slide) => {
				const isClone = slide.classList.contains('tns-slide-cloned');
				slide.inert = isClone ||
					(sliderEnabled && slide.getAttribute('aria-hidden') === 'true');
				if (!sliderEnabled && !isClone) {
					slide.removeAttribute('aria-hidden');
					slide.removeAttribute('tabindex');
				}
			});
		};

		const testimonialsSlider = tns({
			...defaults,
			...options,
			autoplay: autoplayEnabled,
			autoplayButtonOutput: false,
			onInit: updateSlideFocus,
		});

		this.prevButton?.removeAttribute('tabindex');
		this.nextButton?.removeAttribute('tabindex');

		updateSlideFocus();
		testimonialsSlider.events.on('transitionEnd', updateSlideFocus);
		testimonialsSlider.events.on('newBreakpointEnd', updateSlideFocus);

		if (autoplayEnabled) {
			const root = this.el.closest('.block-testimonials');
			const autoplayToggle = root?.querySelector('[data-slider-autoplay-toggle]');
			wireTnsAutoplayToggle(testimonialsSlider, autoplayToggle);
		}

		return testimonialsSlider;
	}
}

export default TestimonialsSlider;
